import { InjectableClass } from '@fino/lib-injection';
import signatureModal from './modal/crop/cropModal.html';
import _ from 'lodash';

export class CropService extends InjectableClass {
  constructor($uibModal, $uibModalStack) {
    'ngInject';
    super({ $uibModal, $uibModalStack });
  }

  openModal(scope) {
    this.signatureModalInstance = this.$uibModal.open({
      animation: true,
      scope,
      template: signatureModal,
      windowClass: 'crop-modal',
      bindToController: true,
      controllerAs: 'vm',
      size: 'lg'
    });
  }

  closeModal() {
    if (this.signatureModalInstance) {
      this.signatureModalInstance.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-signature-pad/src/signaturePad.crop.service.js